import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { Department } from './types/department.type';

/**
 * Fetches the list of departments (`sec.group`).
 *
 * @param instance - Ky HTTP instance from the application store.
 * @returns OperationResultWithData wrapping `Department[]`.
 */
export const getDepartments = async (instance: KyInstance) => {
  try {
    return await instance.get<OperationResultWithData<Department[]>>(Uri.departments.base).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
